import { ITab } from 'components/organisms/Tabs';

export enum EFAQTabs {
    Writer = 'writer',
    Agent = 'agent',
}

export type TFAQTabs = ITab<EFAQTabs>[];
